import { TThunkAction } from '../../types/redux';
import { EStatus } from '../../types/likes';
import { setReviewReactionAction } from './actions';
import {
  TSetReviewReactionWebResponse_1,
  ISetReviewReactionWebResponse200,
  ISetReviewReactionWebResponse400,
  fetchSetReviewReactionWeb,
} from '../../repositories/newbuilding-reviews/v1/set-review-reaction-web';
import { mapLabelFromState, trackReactionAnalyticClick } from './analytics/reactionAnalytic';
import { getReviewById } from '../../selectors/reviews';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_review_reaction_web/SetReviewReactionWebRequestSchema';

interface IParams {
  reviewId: string;
  type: EStatus;
}

export function setReviewReaction({ reviewId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const siteType = context.custom.deviceType;
      const state = getState();
      const rating = getNewbuildingRating(state);
      const { like } = getReviewById(reviewId)(state);
      const { response } = await fetchSetReviewReactionWeb<
        ISetReviewReactionWebResponse200,
        ISetReviewReactionWebResponse400
      >({
        httpApi,
        parameters: { reviewId, type: type as unknown as EType },
      });

      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as TSetReviewReactionWebResponse_1).type as unknown as EStatus,
      });

      dispatch(
        setReviewReactionAction({
          reviewId,
          type: (response as TSetReviewReactionWebResponse_1).type as unknown as EStatus,
        }),
      );

      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          review_id: reviewId,
          type: 'review',
        },
      };

      // Обернуто в setTimeout для улучшения INP
      setTimeout(() => trackReactionAnalyticClick({ label, page }), 0);

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'answers#setAnswerReaction',
        message: error.message,
      });

      return false;
    }
  };
}
